@if (toast$ | async; as toast) {
  @if (toast.isOpen) {
    <div class="fixed bottom-6 right-6 z-120 min-w-72 max-w-96 rounded-lg border bg-white shadow-lg px-4 py-3 flex items-center gap-3"
         [ngClass]="{
           'border-primary_color': toast.tone === 'success',
           'border-warning': toast.tone === 'info',
           'border-danger': toast.tone === 'error'
         }">
      <div class="size-2 rounded-full"
           [ngClass]="{
             'bg-primary_color': toast.tone === 'success',
             'bg-warning': toast.tone === 'info',
             'bg-danger': toast.tone === 'error'
           }"></div>
      <p class="text-sm text-text_dark flex-1">{{ toast.message | translate }}</p>
      <button type="button" class="text-text_gray hover:text-text_dark" (click)="closeToast()" aria-label="Close toast">
        ×
      </button>
    </div>
  }
}
